export default function CallButton() {
  const phoneNumber = '+919677255272'

  return (
    <a
      href={`tel:${phoneNumber}`}
      className="call-float"
      aria-label="Call us"
    >
      <i className="fas fa-phone-alt"></i>
    </a>
  )
}